// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"3032547a","949":"5816d6f2"}[chunkId] + ".chunk.js";
};